import React from "react";
import { ArrowRight, CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutUs() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="32543" id="detalles-del-curso" className="bg-background py-24 overflow-hidden" ref={ref}>
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {}
          <div className={`lg:col-span-5 flex flex-col gap-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            <div className="space-y-4">
              <h2 className="text-5xl font-extrabold text-foreground tracking-tighter uppercase">
                Barbería Profesional
              </h2>
              <p className="text-xl font-bold text-primary tracking-tight">
                4 Meses | Modalidad Presencial
              </p>
            </div>

            <div className="space-y-6 text-lg leading-relaxed text-muted-foreground font-medium">
              <p>
                Nuestra formación integral en barbería está diseñada para convertirte en un profesional de élite. Aprenderás desde las técnicas más tradicionales de corte y afeitado hasta las tendencias de vanguardia que dominan el mercado actual.
              </p>
              <p>
                En ECAP, nos enfocamos en la práctica constante con herramientas profesionales y supervisión experta. Al finalizar, contarás con una certificación oficial válida en todo el país para tu inserción laboral inmediata.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-2 items-baseline">
              <span className="text-sm font-bold text-muted-foreground uppercase tracking-widest">
                Inversión del curso
              </span>
              <span className="text-4xl font-extrabold text-secondary font-mono tracking-tighter ![margin:0px_100px_0px_70px]">
                $19500
              </span>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-4">
              {["Corte Clásico y Moderno", "Barboterapia Profesional", "Diseño y Perfilado", "Gestión de Barberías"].map((item, i) => <div key={i} data-index={i} className="flex items-center gap-2">
                  <CircleCheck className="h-5 w-5 text-secondary shrink-0" />
                  <span className="text-sm font-bold text-foreground/90 uppercase tracking-wide">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          {}
          <div className={`lg:col-span-7 relative transition-all duration-700 ease-out delay-200 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl bg-card border border-border/50">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/professional_barbershop_training.png" alt="Estudiantes de barbería en formación práctica profesional" className="w-full h-auto object-cover hover:scale-105 transition-transform duration-1000" />
              {}
              <div className="absolute inset-0 ring-1 ring-inset ring-white/10 rounded-3xl pointer-events-none" />
              <div className="absolute inset-0 bg-gradient-to-t from-background/20 to-transparent pointer-events-none" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}